(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const accordionRoot = document.querySelector('[data-accordion-root]');
    if (!accordionRoot) {
      return;
    }

    const section = accordionRoot.closest('.shopify-section') || document;

    const allowMultiple = accordionRoot.dataset.allowMultiple === 'true';
    const openFirst = accordionRoot.dataset.openFirst === 'true';

    const triggers = Array.from(accordionRoot.querySelectorAll('[data-accordion-trigger]'));

    const getPanel = (trigger) => {
      const panelId = trigger.getAttribute('aria-controls');

      if (!panelId) {
        return null;
      }

      const panel = accordionRoot.querySelector(`#${panelId}`);
      return panel;
    };

    const setExpandedState = (trigger, expanded) => {
      const panel = getPanel(trigger);
      if (!panel) {
        return;
      }

      const content = panel.querySelector('[data-accordion-content]');

      if (!content) {
        return;
      }

      if (expanded) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        content.removeAttribute('inert');

        const height = content.scrollHeight;
        panel.style.height = `${height}px`;

        requestAnimationFrame(() => {
          panel.style.opacity = '1';
        });

        return;
      }

      const height = content.scrollHeight;
      panel.style.height = `${height}px`;
      panel.style.opacity = '1';

      requestAnimationFrame(() => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        content.setAttribute('inert', '');

        panel.style.height = '0px';
        panel.style.opacity = '0';
      });
    };

    const syncOpenPanelHeights = () => {
      triggers.forEach((trigger) => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (!expanded) return;

        const panel = getPanel(trigger);
        const content = panel?.querySelector('[data-accordion-content]');

        if (!panel || !content) {
          return;
        }

        const height = content.scrollHeight;

        panel.style.height = `${height}px`;
        panel.style.opacity = '1';
      });
    };

    triggers.forEach((trigger, index) => {
      const panel = getPanel(trigger);
      const content = panel?.querySelector('[data-accordion-content]');

      if (!panel || !content) {
        return;
      }

      if (openFirst && index === 0) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');

        const height = content.scrollHeight;

        panel.style.height = `${height}px`;
        panel.style.opacity = '1';
        content.removeAttribute('inert');
      } else {
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');

        panel.style.height = '0px';
        panel.style.opacity = '0';
        content.setAttribute('inert', '');
      }

      panel.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'height') return;

        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          panel.style.height = 'auto';
        }
      });

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        if (!allowMultiple) {
          triggers.forEach((otherTrigger) => {
            if (otherTrigger === trigger) return;

            const otherExpanded = otherTrigger.getAttribute('aria-expanded') === 'true';

            if (otherExpanded) {
              setExpandedState(otherTrigger, false);
            }
          });
        }

        setExpandedState(trigger, !isExpanded);
      });
    });

    window.addEventListener('resize', () => {
      syncOpenPanelHeights();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["age-verification-dialog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selectors = '[data-age-verification]';
    var acceptedValue = 'age_state_v1';

    function getCookie(name) {
      var nameEq = name + '=';
      var cookies = document.cookie.split(';');

      for (var i = 0; i < cookies.length; i += 1) {
        var cookie = cookies[i];

        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1, cookie.length);
        }

        if (cookie.indexOf(nameEq) === 0) {
          return decodeURIComponent(cookie.substring(nameEq.length, cookie.length));
        }
      }

      return null;
    }

    function setCookie(name, value, days) {
      var maxAge = days * 24 * 60 * 60;
      var cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
      document.cookie = cookie;
    }

    function getStoredValue(storageKey) {
      try {
        var storedValue = window.localStorage.getItem(storageKey);

        if (storedValue) {
          return storedValue;
        }
      } catch (error) {
        // Ignore localStorage read failures.
      }

      return getCookie(storageKey) || '';
    }

    function setStoredValue(storageKey, value, cookieDays) {
      try {
        window.localStorage.setItem(storageKey, value);
      } catch (error) {
        // Ignore localStorage write failures.
      }

      setCookie(storageKey, value, cookieDays);
    }

    function markAccepted(storageKey, cookieDays) {
      setStoredValue(storageKey, acceptedValue, cookieDays);
    }

    function isAccepted(storageKey, shippingStateKey, hideStateSelector) {
      if (getStoredValue(storageKey) !== acceptedValue) return false;
      if (hideStateSelector) return true;

      return Boolean(getStoredValue(shippingStateKey));
    }

    function openDialog(container, lockScroll) {
      container.hidden = false;

      if (lockScroll) {
        document.body.classList.add('age-verification-open');
      }
    }

    function closeDialog(container) {
      container.hidden = true;
      document.body.classList.remove('age-verification-open');
    }

    var containers = document.querySelectorAll(selectors);

    containers.forEach(function (container) {
      var enabled = container.dataset.enabled === 'true';

      if (!enabled) {
        closeDialog(container);
        return;
      }

      var storageKey = container.dataset.storageKey;
      if (!storageKey) {
        storageKey = 'earthly_age_verified';
      }

      var cookieDays = Number(container.dataset.cookieDays);
      if (!cookieDays || cookieDays < 1) {
        cookieDays = 365;
      }

      var lockScroll = container.dataset.lockScroll === 'true';
      var hideStateSelector = container.dataset.hideStateSelector === 'true';
      var shippingStateKey = container.dataset.shippingStateKey || 'earthly_shipping_state';
      var acceptButton = container.querySelector('[data-age-verify-accept]');
      var form = container.querySelector('[data-age-verify-form]');
      var stateSelect = container.querySelector('[data-age-verify-state]');
      var message = container.querySelector('[data-age-verify-message]');

      if (!acceptButton) {
        closeDialog(container);
        return;
      }

      if (!hideStateSelector) {
        if (!form || !stateSelect || !message) {
          closeDialog(container);
          return;
        }

        stateSelect.value = getStoredValue(shippingStateKey);
      }

      if (isAccepted(storageKey, shippingStateKey, hideStateSelector)) {
        closeDialog(container);
        return;
      }

      function setMessage(text) {
        if (!message) return;

        message.textContent = text || '';
      }

      function getVerificationState() {
        if (hideStateSelector) {
          return { valid: true, state: '', message: '' };
        }

        var selectedState = stateSelect.value;

        if (!selectedState) {
          return { valid: false, state: selectedState, message: 'Select your state of residence to continue.' };
        }

        return { valid: true, state: selectedState, message: '' };
      }

      function syncVerificationState() {
        var verificationState = getVerificationState();

        acceptButton.classList.toggle('is-visible', verificationState.valid);
        acceptButton.hidden = !verificationState.valid;
        setMessage(verificationState.message);
      }

      acceptButton.hidden = !hideStateSelector;
      syncVerificationState();
      openDialog(container, lockScroll);

      acceptButton.addEventListener('click', function () {
        var verificationState = getVerificationState();

        if (!verificationState.valid) {
          syncVerificationState();
          return;
        }

        if (!hideStateSelector) {
          setStoredValue(shippingStateKey, verificationState.state, 365);
          window.dispatchEvent(
            new CustomEvent('earthly:shipping-state-change', {
              detail: { state: verificationState.state },
            })
          );
        }

        markAccepted(storageKey, cookieDays);
        closeDialog(container);
      });

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();

          if (!acceptButton.hidden) {
            acceptButton.click();
          }
        });
      }

      if (stateSelect) {
        stateSelect.addEventListener('change', syncVerificationState);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const section = document.querySelector('.cart-page');
    if (!section) return;

    const steppers = section.querySelectorAll('[data-quantity-stepper]');
    if (!steppers.length) return;

    steppers.forEach((stepper) => {
      const input = stepper.querySelector('[data-quantity-input]');
      const decrease = stepper.querySelector('[data-quantity-decrease]');
      const increase = stepper.querySelector('[data-quantity-increase]');

      if (!input || !decrease || !increase) return;

      const syncValue = (nextValue) => {
        const parsedValue = Number.parseInt(nextValue, 10);
        const minValue = Number.parseInt(input.getAttribute('min') || '1', 10);
        const safeValue = Number.isNaN(parsedValue) ? minValue : Math.max(minValue, parsedValue);

        input.value = safeValue;
      };

      decrease.addEventListener('click', () => {
        syncValue((Number.parseInt(input.value || '1', 10) || 1) - 1);
      });

      increase.addEventListener('click', () => {
        syncValue((Number.parseInt(input.value || '1', 10) || 1) + 1);
      });

      input.addEventListener('change', () => {
        syncValue(input.value);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const scope = document.querySelector('.catalog[data-section-id]');

    if (!scope) {
      return;
    }

    const initialSectionId = scope.dataset.sectionId;
    const VIEW_PARAM = 'view';
    const STORAGE_KEY = 'earthly-catalog-layout';
    const VALID_VIEW_MODES = ['feature', 'compact', 'list'];

    const isValidViewMode = (value) => VALID_VIEW_MODES.includes(value);

    const formatRangeValue = (value) => {
      const normalizedValue = Math.round(value * 100) / 100;

      if (Number.isInteger(normalizedValue)) {
        return String(normalizedValue);
      }

      return normalizedValue.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    };

    const readStoredViewMode = () => {
      const searchParams = new URLSearchParams(window.location.search);
      const queryViewMode = searchParams.get(VIEW_PARAM);

      if (isValidViewMode(queryViewMode)) {
        return queryViewMode;
      }

      try {
        const storedViewMode = window.localStorage.getItem(STORAGE_KEY);

        if (isValidViewMode(storedViewMode)) {
          return storedViewMode;
        }
      } catch (error) {
        // Ignore localStorage failures; the default view will be used.
      }

      return scope.dataset.defaultLayoutMode || 'feature';
    };

    const updateViewUrl = (viewMode) => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set(VIEW_PARAM, viewMode);
      window.history.replaceState({}, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
    };

    const syncViewInputs = (viewMode) => {
      scope.querySelectorAll('[data-catalog-view-input]').forEach((input) => {
        input.value = viewMode;
      });

      scope.querySelectorAll('[data-catalog-reset-link]').forEach((link) => {
        const nextUrl = new URL(link.href, window.location.origin);
        nextUrl.searchParams.set(VIEW_PARAM, viewMode);
        link.href = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      });
    };

    const applyViewMode = (viewMode, options = {}) => {
      const { persist = true } = options;

      if (!isValidViewMode(viewMode)) {
        return;
      }

      const body = scope.querySelector('[data-catalog-body]');

      if (body) {
        body.dataset.layoutMode = viewMode;
      }

      scope.querySelectorAll('[data-catalog-layout-option]').forEach((button) => {
        const isActive = button.dataset.catalogLayoutOption === viewMode;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      syncViewInputs(viewMode);

      if (!persist) {
        return;
      }

      try {
        window.localStorage.setItem(STORAGE_KEY, viewMode);
      } catch (error) {
        // Ignore localStorage failures; the URL still preserves the state.
      }

      updateViewUrl(viewMode);
    };

    const createPanelController = (sectionScope) => {
      const panelButtons = sectionScope.querySelectorAll('[data-catalog-panel-toggle]');
      const panels = sectionScope.querySelectorAll('[data-catalog-mobile-panel]');
      const closeButtons = sectionScope.querySelectorAll('[data-catalog-panel-close]');

      const closePanels = () => {
        panelButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        panels.forEach((panel) => {
          panel.hidden = true;
        });
      };

      panelButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const panelName = button.dataset.catalogPanelToggle;
          const targetPanel = sectionScope.querySelector(`[data-catalog-mobile-panel="${panelName}"]`);

          if (!targetPanel) {
            return;
          }

          const shouldOpen = targetPanel.hidden;
          closePanels();

          if (!shouldOpen) {
            return;
          }

          targetPanel.hidden = false;
          button.setAttribute('aria-expanded', 'true');
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closePanels);
      });

      const handleResize = () => {
        if (window.innerWidth >= 750) {
          closePanels();
        }
      };

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    };

    const createPriceRange = (priceRangeRoot) => {
      if (priceRangeRoot.dataset.catalogPriceRangeBound === 'true') {
        return;
      }

      priceRangeRoot.dataset.catalogPriceRangeBound = 'true';

      const form = priceRangeRoot.closest('form');
      const minRange = priceRangeRoot.querySelector('[data-price-range-control="min"]');
      const maxRange = priceRangeRoot.querySelector('[data-price-range-control="max"]');
      const minNumber = form ? form.querySelector('[data-price-range-number="min"]') : null;
      const maxNumber = form ? form.querySelector('[data-price-range-number="max"]') : null;

      if (!form || !minRange || !maxRange || !minNumber || !maxNumber) {
        return;
      }

      const rangeMax = Number(priceRangeRoot.dataset.rangeMax || maxRange.max || 0) || 0;

      const updateVisuals = (minValue, maxValue) => {
        const minPercent = rangeMax > 0 ? (minValue / rangeMax) * 100 : 0;
        const maxPercent = rangeMax > 0 ? (maxValue / rangeMax) * 100 : 100;
        priceRangeRoot.style.setProperty('--range-min-percent', `${minPercent}%`);
        priceRangeRoot.style.setProperty('--range-max-percent', `${maxPercent}%`);
      };

      const setVisibleNumbers = (minValue, maxValue) => {
        minNumber.value = minValue > 0 ? formatRangeValue(minValue) : '';
        maxNumber.value = maxValue < rangeMax ? formatRangeValue(maxValue) : '';
      };

      const readNumbers = () => {
        let nextMinValue = minNumber.value === '' ? 0 : Number(minNumber.value);
        let nextMaxValue = maxNumber.value === '' ? rangeMax : Number(maxNumber.value);

        if (!Number.isFinite(nextMinValue) || nextMinValue < 0) {
          nextMinValue = 0;
        }

        if (!Number.isFinite(nextMaxValue) || nextMaxValue > rangeMax) {
          nextMaxValue = rangeMax;
        }

        if (nextMinValue > nextMaxValue) {
          nextMaxValue = nextMinValue;
        }

        return {
          minValue: nextMinValue,
          maxValue: nextMaxValue,
        };
      };

      const syncFromRanges = (source) => {
        let minValue = Number(minRange.value || 0);
        let maxValue = Number(maxRange.value || rangeMax);

        if (source === 'min' && minValue > maxValue) {
          maxValue = minValue;
          maxRange.value = String(maxValue);
        }

        if (source === 'max' && maxValue < minValue) {
          minValue = maxValue;
          minRange.value = String(minValue);
        }

        setVisibleNumbers(minValue, maxValue);
        updateVisuals(minValue, maxValue);
      };

      const syncFromNumbers = () => {
        const { minValue, maxValue } = readNumbers();
        minRange.value = String(minValue);
        maxRange.value = String(maxValue);
        setVisibleNumbers(minValue, maxValue);
        updateVisuals(minValue, maxValue);
      };

      minRange.addEventListener('input', () => {
        syncFromRanges('min');
      });

      maxRange.addEventListener('input', () => {
        syncFromRanges('max');
      });

      minRange.addEventListener('change', () => {
        syncFromRanges('min');
        form.submit();
      });

      maxRange.addEventListener('change', () => {
        syncFromRanges('max');
        form.submit();
      });

      [minNumber, maxNumber].forEach((input) => {
        input.addEventListener('input', () => {
          syncFromNumbers();
        });

        input.addEventListener('change', () => {
          syncFromNumbers();
          form.submit();
        });

        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') {
            return;
          }

          event.preventDefault();
          syncFromNumbers();
          form.submit();
        });
      });

      syncFromNumbers();
    };

    const createFilters = (sectionScope) => {
      sectionScope.querySelectorAll('[data-catalog-filter-form]').forEach((form) => {
        if (form.dataset.catalogFilterFormBound === 'true') {
          return;
        }

        form.dataset.catalogFilterFormBound = 'true';

        form.querySelectorAll('[data-catalog-auto-submit]').forEach((input) => {
          input.addEventListener('change', () => {
            form.submit();
          });
        });

        form.querySelectorAll('[data-price-range-root]').forEach((priceRangeRoot) => {
          createPriceRange(priceRangeRoot);
        });
      });
    };

    const createSortForms = (sectionScope) => {
      sectionScope.querySelectorAll('[data-catalog-sort]').forEach((select) => {
        if (select.dataset.catalogSortBound === 'true') {
          return;
        }

        select.dataset.catalogSortBound = 'true';

        select.addEventListener('change', () => {
          if (select.form) {
            select.form.submit();
          }
        });
      });
    };

    const createAjaxinate = (sectionScope) => {
      const sectionId = sectionScope.dataset.sectionId;

      if (!sectionId) {
        return;
      }

      const containerSelector = `#AjaxinateContainer-${sectionId}`;
      const paginationSelector = `#AjaxinatePagination-${sectionId}`;

      if (sectionScope.ajaxinateInstance) {
        sectionScope.ajaxinateInstance.destroy();
      }

      if (typeof window.Ajaxinate !== 'function') {
        return;
      }

      const containerElement = sectionScope.querySelector(containerSelector);
      const paginationElement = sectionScope.querySelector(paginationSelector);

      if (!containerElement || !paginationElement) {
        return;
      }

      sectionScope.ajaxinateInstance = new window.Ajaxinate({
        method: 'scroll',
        container: containerSelector,
        pagination: paginationSelector,
        offset: 300,
        loadingText: 'Loading more products...',
      });
    };

    const createParallax = (sectionScope) => {
      const hero = sectionScope.querySelector('[data-catalog-hero]');

      if (!hero) {
        return () => {};
      }

      const mobileMedia = window.matchMedia('(max-width: 749px)');
      const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      const prefersLowData = navigator.connection && navigator.connection.saveData;
      let animationFrame = 0;
      let isHeroVisible = true;
      let observer;

      const bindMediaQueryChange = (mediaQuery, listener) => {
        if (typeof mediaQuery.addEventListener === 'function') {
          mediaQuery.addEventListener('change', listener);

          return () => {
            mediaQuery.removeEventListener('change', listener);
          };
        }

        mediaQuery.addListener(listener);

        return () => {
          mediaQuery.removeListener(listener);
        };
      };

      const shouldDisableParallax = () => {
        if (prefersLowData) {
          return true;
        }

        if (mobileMedia.matches) {
          return true;
        }

        if (reducedMotionMedia.matches) {
          return true;
        }

        return false;
      };

      const updateParallax = () => {
        animationFrame = 0;

        if (shouldDisableParallax() || !isHeroVisible) {
          hero.style.setProperty('--catalog-hero-parallax', '0px');
          return;
        }

        const heroRect = hero.getBoundingClientRect();
        const parallaxOffset = Math.max(Math.min(heroRect.top * -0.5, 400), 0);
        hero.style.setProperty('--catalog-hero-parallax', `${parallaxOffset}px`);
      };

      const requestParallaxFrame = () => {
        if (animationFrame) {
          return;
        }

        animationFrame = window.requestAnimationFrame(updateParallax);
      };

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            isHeroVisible = entry.isIntersecting;
          });

          if (isHeroVisible) {
            requestParallaxFrame();
          }
        });

        observer.observe(hero);
      }

      // Disable the effect in reduced-motion, mobile, or save-data contexts to avoid scroll jank.
      const unbindMobileMedia = bindMediaQueryChange(mobileMedia, requestParallaxFrame);
      const unbindReducedMotionMedia = bindMediaQueryChange(reducedMotionMedia, requestParallaxFrame);

      window.addEventListener('scroll', requestParallaxFrame, { passive: true });
      window.addEventListener('resize', requestParallaxFrame);
      requestParallaxFrame();

      return () => {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
        }

        if (observer) {
          observer.disconnect();
        }

        window.removeEventListener('scroll', requestParallaxFrame);
        window.removeEventListener('resize', requestParallaxFrame);
        unbindMobileMedia();
        unbindReducedMotionMedia();
      };
    };

    const initializeCatalogSection = (sectionScope) => {
      const cleanups = [];

      applyViewMode(readStoredViewMode(), { persist: false });
      createFilters(sectionScope);
      createSortForms(sectionScope);
      cleanups.push(createPanelController(sectionScope));
      cleanups.push(createParallax(sectionScope));

      if (typeof window.Ajaxinate === 'function') {
        createAjaxinate(sectionScope);
      } else {
        document.addEventListener(
          'DOMContentLoaded',
          () => {
            createAjaxinate(sectionScope);
          },
          { once: true }
        );
      }

      sectionScope.catalogCleanups = cleanups;
    };

    const destroyCatalogSection = (sectionScope) => {
      if (sectionScope.catalogCleanups) {
        sectionScope.catalogCleanups.forEach((cleanup) => {
          if (typeof cleanup === 'function') {
            cleanup();
          }
        });
      }

      if (sectionScope.ajaxinateInstance) {
        sectionScope.ajaxinateInstance.destroy();
        delete sectionScope.ajaxinateInstance;
      }

      delete sectionScope.catalogCleanups;
    };

    scope.querySelectorAll('[data-catalog-layout-option]').forEach((button) => {
      button.addEventListener('click', () => {
        const nextViewMode = button.dataset.catalogLayoutOption;

        if (!isValidViewMode(nextViewMode)) {
          return;
        }

        applyViewMode(nextViewMode);
      });
    });

    initializeCatalogSection(scope);

    document.addEventListener('shopify:section:load', (event) => {
      const sectionScope = event.target;

      if (sectionScope.dataset.sectionId !== initialSectionId) {
        return;
      }

      initializeCatalogSection(sectionScope);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const sectionScope = event.target;

      if (sectionScope.dataset.sectionId !== initialSectionId) {
        return;
      }

      destroyCatalogSection(sectionScope);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const CALLBACK_NAME = '__earthlyStoreLocatorMapsReady';
    const instances = new WeakMap();

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => {
        const entities = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;',
        };

        return entities[character];
      });
    }

    function sanitizeUrl(value) {
      if (!value) return '';

      try {
        const url = new URL(value, window.location.origin);

        if (url.protocol === 'http:' || url.protocol === 'https:') {
          return url.href;
        }
      } catch (error) {
        return '';
      }

      return '';
    }

    function getNumber(value, fallback) {
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    function getConfig(section) {
      const configElement = section.querySelector('[data-store-locator-config]');

      if (!configElement) return null;

      try {
        return JSON.parse(configElement.textContent);
      } catch (error) {
        return null;
      }
    }

    function showMapMessage(section, message) {
      const messageElement = section.querySelector('[data-store-map-message]');

      if (!messageElement) return;

      messageElement.textContent = message;
      messageElement.hidden = false;
    }

    function loadMaps(config) {
      if (window.google && window.google.maps && window.google.maps.importLibrary) {
        return Promise.resolve(window.google.maps);
      }

      if (window.EarthlyStoreLocatorMapsPromise) {
        return window.EarthlyStoreLocatorMapsPromise;
      }

      window.EarthlyStoreLocatorMapsPromise = new Promise((resolve, reject) => {
        window[CALLBACK_NAME] = () => {
          resolve(window.google.maps);
        };

        const parameters = new URLSearchParams({
          key: config.apiKey,
          loading: 'async',
          callback: CALLBACK_NAME,
          v: 'weekly',
          libraries: 'marker',
        });

        if (config.mapId) {
          parameters.set('map_ids', config.mapId);
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?${parameters.toString()}`;
        script.async = true;
        script.onerror = () => reject(new Error('Google Maps failed to load.'));
        document.head.appendChild(script);
      });

      return window.EarthlyStoreLocatorMapsPromise;
    }

    function getStorePosition(store) {
      const lat = parseFloat(store.latitude);
      const lng = parseFloat(store.longitude);

      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        return { lat, lng };
      }

      return null;
    }

    function geocodeStore(store, geocoder) {
      const position = getStorePosition(store);

      if (position) return Promise.resolve(position);
      if (!store.address || !geocoder) return Promise.resolve(null);

      return new Promise((resolve) => {
        geocoder.geocode({ address: store.address }, (results, status) => {
          if (status !== 'OK' || !results || !results[0]) {
            resolve(null);
            return;
          }

          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
        });
      });
    }

    function createInfoContent(store) {
      const directionsUrl = sanitizeUrl(store.directionsUrl);
      const addressMarkup = store.address ? `<p class="store-locator__info-text">${escapeHtml(store.address)}</p>` : '';
      const phoneMarkup = store.phone ? `<p class="store-locator__info-text">${escapeHtml(store.phone)}</p>` : '';
      const linkMarkup = directionsUrl
        ? `<a class="store-locator__info-link" href="${escapeHtml(
            directionsUrl
          )}" target="_blank" rel="noopener">Directions</a>`
        : '';

      return `
        <div class="store-locator__info">
          <h3 class="store-locator__info-title">${escapeHtml(store.name)}</h3>
          ${addressMarkup}
          ${phoneMarkup}
          ${linkMarkup}
        </div>
      `;
    }

    function setActiveCard(section, index) {
      section.querySelectorAll('[data-store-card]').forEach((card) => {
        const isActive = card.dataset.storeIndex === String(index);
        card.classList.toggle('is-active', isActive);
      });
    }

    function focusStore(section, index) {
      const instance = instances.get(section);
      if (!instance) return;

      const markerData = instance.markers.get(Number(index));
      if (!markerData) return;

      instance.map.panTo(markerData.position);
      instance.map.setZoom(instance.selectedZoom);
      instance.infoWindow.setContent(createInfoContent(markerData.store));
      instance.infoWindow.open({
        anchor: markerData.marker,
        map: instance.map,
      });
      setActiveCard(section, index);
    }

    function updateSearch(section) {
      const input = section.querySelector('[data-store-search]');
      const noResults = section.querySelector('[data-store-no-results]');
      const count = section.querySelector('[data-store-count]');
      const query = input ? input.value.trim().toLowerCase() : '';
      let visibleCount = 0;

      section.querySelectorAll('[data-store-card]').forEach((card) => {
        const matches = !query || card.dataset.storeSearchText.includes(query);
        card.hidden = !matches;

        if (matches) visibleCount += 1;
      });

      if (noResults) {
        noResults.hidden = visibleCount !== 0;
      }

      if (count) {
        count.textContent = `${visibleCount} ${visibleCount === 1 ? 'store' : 'stores'}`;
      }
    }

    async function initStoreLocator(section) {
      if (!section || instances.has(section)) return;

      const config = getConfig(section);
      const mapElement = section.querySelector('[data-store-map]');

      if (!config || !mapElement) return;

      if (!config.apiKey) {
        showMapMessage(section, 'Add a Google Maps API key to load the map.');
        return;
      }

      try {
        await loadMaps(config);
        const mapsLibrary = await google.maps.importLibrary('maps');
        const markerLibrary = await google.maps.importLibrary('marker');
        const center = {
          lat: getNumber(config.defaultCenter && config.defaultCenter.lat, 35.7796),
          lng: getNumber(config.defaultCenter && config.defaultCenter.lng, -78.6382),
        };
        const defaultZoom = Math.round(getNumber(config.defaultZoom, 10));
        const selectedZoom = Math.round(getNumber(config.selectedZoom, 14));
        const map = new mapsLibrary.Map(mapElement, {
          center,
          zoom: defaultZoom,
          mapId: config.mapId || undefined,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
        });
        const geocoder = new google.maps.Geocoder();
        const infoWindow = new google.maps.InfoWindow();
        const markers = new Map();
        const bounds = new google.maps.LatLngBounds();
        const pinColor = '#2f6f5e';
        const pinAccent = '#ffffff';
        const canUseAdvancedMarker = Boolean(markerLibrary.AdvancedMarkerElement && config.mapId);

        instances.set(section, {
          map,
          markers,
          infoWindow,
          selectedZoom,
        });

        const storePositions = await Promise.all(config.stores.map((store) => geocodeStore(store, geocoder)));

        storePositions.forEach((position, index) => {
          if (!position) return;

          const store = config.stores[index];
          const pin =
            canUseAdvancedMarker && markerLibrary.PinElement
              ? new markerLibrary.PinElement({
                  background: pinColor,
                  borderColor: pinAccent,
                  glyphColor: pinAccent,
                  scale: 1.1,
                })
              : null;
          const marker = canUseAdvancedMarker
            ? new markerLibrary.AdvancedMarkerElement({
                map,
                position,
                title: store.name,
                content: pin ? pin.element : undefined,
                gmpClickable: true,
              })
            : new google.maps.Marker({
                map,
                position,
                title: store.name,
              });

          if (marker.addEventListener) {
            marker.addEventListener('gmp-click', () => focusStore(section, index));
          } else {
            marker.addListener('click', () => focusStore(section, index));
          }
          markers.set(index, {
            marker,
            position,
            store,
            index,
          });
          bounds.extend(position);
        });

        if (markers.size > 1) {
          map.fitBounds(bounds, 48);
        } else if (markers.size === 1) {
          const firstMarker = markers.values().next().value;
          map.setCenter(firstMarker.position);
          map.setZoom(selectedZoom);
          setActiveCard(section, firstMarker.index);
        }
      } catch (error) {
        showMapMessage(section, 'Map unavailable right now.');
      }

      const searchInput = section.querySelector('[data-store-search]');

      if (searchInput) {
        searchInput.addEventListener('input', () => updateSearch(section));
      }

      section.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-store-focus]');
        if (!trigger) return;

        const card = trigger.closest('[data-store-card]');
        if (!card) return;

        focusStore(section, card.dataset.storeIndex);
      });

      updateSearch(section);
    }

    function initAllStoreLocators() {
      document.querySelectorAll('[data-store-locator]').forEach(initStoreLocator);
    }

    document.addEventListener('DOMContentLoaded', initAllStoreLocators);
    document.addEventListener('shopify:section:load', (event) => {
      initStoreLocator(event.target.querySelector('[data-store-locator]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
